<mat-expansion-panel class="elt__expansion-panel">
  <mat-expansion-panel-header class="elt__expansion-panel-header">
    <mat-panel-title class="elt__panel-title">
      <i class="material-icons">inventory_2</i> Boîte - {{box?.box_number}}
    </mat-panel-title>
    <mat-panel-description class="elt__panel-description">
      Nombre de document(s): {{box?.documents_obj?.length}}
    </mat-panel-description>
  </mat-expansion-panel-header>

  <mat-card>
    <mat-card-content>
      <div fxLayout="row">
        <mat-list role="list" fxFlex="50%">
          <mat-list-item role="listitem">
            <div fxLayout="column">
              <span class="lbl">Numéro de la boîte</span>
              <span class="ctt">{{box?.box_number}}</span>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div fxLayout="column">
              <span class="lbl">Type de boîte</span>
              <span class="ctt">{{boxSvc.displayBoxType(box)}}</span>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div fxLayout="column">
              <span class="lbl">Année de révision min</span>
              <span class="ctt">{{box?.revision_year_min}}</span>
            </div>
          </mat-list-item>
        </mat-list>
        <mat-list role="list" fxFlex>
          <mat-list-item role="listitem">
            <div fxLayout="column">
              <span class="lbl">Description de la boîte</span>
              <span class="ctt">{{box?.description}}</span>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div fxLayout="column">
              <span class="lbl">Nombre de document(s)</span>
              <span class="ctt">{{box?.documents_obj?.length}}</span>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div fxLayout="column">
              <span class="lbl">Année de révision max</span>
              <span class="ctt">{{box?.revision_year_max}}</span>
            </div>
          </mat-list-item>
        </mat-list>
      </div>
      <app-boite-observation [box]="box" *ngIf="individuSvc.isGestionnaire"></app-boite-observation>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-content>
        <app-document *ngFor="let document of box.documents_obj" [document]="document"></app-document>
    </mat-card-content>
  </mat-card>
</mat-expansion-panel>
